import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router';

import apiData from '../data/api';

import './api.component.css';

export default class ApiComponent extends React.Component {
	constructor () {
		super( ...arguments );

		this.state = {
			nav: {
				query: ''
			}
		};
	}

	handleNavInputChange ( event ) {
		this.setState( {
			nav: Object.assign( this.state.nav, {
				query: event.target.value.trim()
			} )
		} );
	}

	render () {
		return (
			< div className = "id-api" >
				< nav className = "bd-nv" >
					< div className = "bn-sm" >
						< input type = "search" placeholder = "搜索..." className = "bn-sf"
							onInput = { this::this.handleNavInputChange }
						/ >
					< /div >

					< ul className = "bn-nl" >
						{
							apiData.map( ( item, key ) => (
								< li className = "bn-ni" key = { key } >
									< div className = "bn-nt" >{ item.name }< /div >

									< ul className = "bn-cl" >
										{
											item.children
												.filter( item => item.name.indexOf( this.state.nav.query ) >= 0 )
												.map( ( item, key ) => (
													< li className = { [ 'bn-ci' ].concat( this.props.params.id === item.name ? [ 'bn-cc' ] : [] ).join(' ') } key = { key } >
														< Link to = { `/api/${ item.name }` } title = { `${ item.name }\n${ item.description }` } >
															< span className = "bn-ct" >{ item.name }< /span >
															< span className = "bn-cd" >{ item.description }< /span >
														< /Link >
													< /li >
												) )
										}
									< /ul >
								< /li >
							) )
						}
					< /ul >
				< /nav >

				< ApiMainComponent id = { this.props.params.id } / >
			< /div >
		);
	}
};

function ApiMainComponent( props ) {
	const id = props.id;

	var data;

	try {
		data = require.context( '../data/api', true, /\.\/wdwd\..+\.json$/ )( `./${ id }.json` );
	}
	catch ( e ) {
		return null;
	}

	if ( !data )
		return null;

	for ( let items of apiData )
		for ( let item of items.children )
			if ( item.name === id )
				return (
					< div className = "bd-mn" >
						< nav className = "bm-nv" >
							< div className = "bm-nh" >
								< div className = "bm-nt" >{ data.id }< /div >
								< div className = "bm-nd" >{ data.description }< /div >
							< /div >

							< ul className = "bm-nl" >
								{
									( (
										data.requests &&
										data.requests.urls &&
										data.requests.urls.length > 0
									) ||
									(
										data.requests.params &&
										data.requests.params.share &&
										data.requests.params.share.length > 0
									) ) &&

									< li className = "bm-ni" >
										< a href = "#requests" title = "公共参数" >公共参数< /a >
									< /li >
								}
								{
									data.requests &&
									data.requests.params &&
									data.requests.params.private &&
									data.requests.params.private.length > 0 &&

									< li className = "bm-ni" >
										< a href = "#requests.private" title = "请求参数" >请求参数< /a >
									< /li >
								}
								{
									data.responses &&
									data.responses.params &&
									data.responses.params.length > 0 &&

									< li className = "bm-ni" >
										< a href = "#responses" title = "响应参数" >响应参数< /a >
									< /li >
								}
								{
									data.structure &&
									data.structure.length > 0 &&

									< li className = "bm-ni" >
										< a href = "#structure" title = "结构类型" >结构类型< /a >
									< /li >
								}
								{
									data.exceptions &&
									data.exceptions.length > 0 &&

									< li className = "bm-ni" >
										< a href = "#exceptions" title = "错误码解释" >错误码解释< /a >
									< /li >
								}
							< /ul >
						< /nav >

						< div className = "bm-mn" >
							< header className = "bs-hd" >
								< h1 className = "bs-ht" >{ data.id }< /h1 >
								< ul className = "bs-hl" >
									{
										data.meta.oauth &&

										< li title = "需要用户授权，才能获取到数据" className = "bs-hi" >需要授权< /li >
									}
								< /ul >
								< p className = "bs-hc" >{ data.description }< /p >
							< /header >

							< div className = "bs-bd" >
								{
									data.requests &&
									data.requests.urls &&
									data.requests.urls.length > 0 &&

									< section id="requests" className = "bs-bs" >
										< h2 className = "bs-bt" >公共参数< /h2 >
										< table className = "bs-t0" >
											< caption >请求地址< /caption >
											< thead >
												< tr >
													< th >环境< /th >
													< th >HTTP请求地址< /th >
													< th >HTTPS请求地址< /th >
												< /tr >
											< /thead >
											< tbody >
												{
													data.requests.urls.map( ( row, key ) => (
														< tr key = { key } >
															< td >{ row.name }< /td >
															< td >{ row.http }< /td >
															< td >{ row.https }< /td >
														< /tr >
													) )
												}
											< /tbody >
										< /table >
										{
											data.requests.params &&
											data.requests.params.share &&
											data.requests.params.share.length > 0 &&

											< table className = "bs-t0" >
												< caption >公共请求参数< /caption >
												< thead >
													< tr >
														< th >名称< /th >
														< th >类型< /th >
														< th >是否必须< /th >
														< th >描述< /th >
													< /tr >
												< /thead >
												< tbody >
													{
														data.requests.params.share.map( ( row, key ) => (
															< tr key = { key } >
																< td >{ row.name }< /td >
																< td >{ row.type }< /td >
																< td >{ row.required ? '是' : '否' }< /td >
																< td >{ row.description }< /td >
															< /tr >
														) )
													}
												< /tbody >
											< /table >
										}
									< /section >
								}
								{
									data.requests &&
									data.requests.params &&
									data.requests.params.private &&
									data.requests.params.private.length > 0 &&

									< section id="requests.private" className = "bs-bs" >
										< h2 className = "bs-bt" >请求参数< /h2 >
										< table className = "bs-t1" >
											< thead >
												< tr >
													< th >名称< /th >
													< th >类型< /th >
													< th >是否必须< /th >
													< th >默认值< /th >
													< th >描述< /th >
												< /tr >
											< /thead >
											< tbody >
												{
													data.requests.params.private.map( ( row, key ) => (
														< tr key = { key } >
															< td >{ row.name }< /td >
															< td >
																{
																	data.structure.filter( item => item.name === row.type ).length > 0 ?
																	< a href = { `#structure:${ row.type }` } >{ row.type }< /a > :
																	row.type
																}
															< /td >
															< td >{ row.required ? '是' : '否' }< /td >
															< td >< /td >
															< td >{ row.description }< /td >
														< /tr >
													) )
												}
											< /tbody >
										< /table >
									< /section >
								}
								{
									data.responses &&
									data.responses.params &&
									data.responses.params.length > 0 &&

									< section id="responses" className = "bs-bs" >
										< h2 className = "bs-bt" >响应参数< /h2 >
										< table className = "bs-t1" >
											< thead >
												< tr >
													< th >名称< /th >
													< th >类型< /th >
													< th >示例值< /th >
													< th >描述< /th >
												< /tr >
											< /thead >
											< tbody >
												{
													data.responses.params.map( ( row, key ) => (
														< tr key = { key } >
															< td >{ row.name }< /td >
															< td >
																{
																	data.structure.filter( item => item.name === row.type ).length > 0 ?
																	< a href = { `#structure:${ row.type }` } >{ row.type }< /a > :
																	row.type
																}
															< /td >
															< td >< /td >
															< td >{ row.description }< /td >
														< /tr >
													) )
												}
											< /tbody >
										< /table >
									< /section >
								}
								{
									data.structure &&
									data.structure.length > 0 &&

									< section id="structure" className = "bs-bs" >
										< h2 className = "bs-bt" >结构类型< /h2 >
										{
											data.structure.map( ( table, key ) => (
												< table id = { `structure:${ table.name }` } className = "bs-t1" key = { key } >
													< caption >{ table.name }< /caption >
													< thead >
														< tr >
															< th >名称< /th >
															< th >类型< /th >
															< th >是否可枚举< /th >
															< th >描述< /th >
														< /tr >
													< /thead >
													< tbody >
														{
															table.params.map( ( row, key ) => (
																< tr key = { key } >
																	< td >{ row.name }< /td >
																	< td >
																		{
																			data.structure.filter( item => item.name === row.type ).length > 0 ?
																			< a href = { `#structure:${ row.type }` } >{ row.type }< /a > :
																			row.type
																		}
																	< /td >
																	< td >{ row.enumerable ? '是' : '否' }< /td >
																	< td >{ row.description }< /td >
																< /tr >
															) )
														}
													< /tbody >
												< /table >
											) )
										}
									< /section >
								}
								{
									data.exceptions &&
									data.exceptions.length > 0 &&

									< section id="exceptions" className = "bs-bs" >
										< h2 className = "bs-bt" >错误码解释< /h2 >
										< table className = "bs-t0" >
											< thead >
												< tr >
													< th >HTTP状态码< /th >
													< th >错误码< /th >
													< th >错误描述< /th >
												< /tr >
											< /thead >
											< tbody >
												{
													data.exceptions.map( ( row, key ) => (
														< tr key = { key } >
															< td >{ row.status }< /td >
															< td >{ row.code }< /td >
															< td >{ row.description }< /td >
														< /tr >
													) )
												}
											< /tbody >
										< /table >
									< /section >
								}
							< /div >
						< /div >
					< /div >
				);

	return null;
}



/** WEBPACK FOOTER **
 ** ./app/components/api.component.js
 **/